import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import IUser from '../../../interfaces/IUser';
import normalizeUser from '../../../utils/normalizeUser';

const userStore = createSlice({
  name: 'user',
  initialState: null as IUser,
  reducers: {
    setUser(_state, action: PayloadAction<IUser>) {
      return normalizeUser(action.payload);
    },
    invalidateUser() {
      return null
    }
  },
});

export default userStore;
export const { setUser, invalidateUser } = userStore.actions;
